<template>
  <!-- 外层只负责把高度撑出来，避免页面抖动 -->
  <div ref="wrap" class="scale-wrap">
    <!-- 真正渲染区域：以 750 宽为基准，整体 transform:scale -->
    <div
      ref="inner"
      class="scale-inner"
      :style="scaleStyle"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScaleBox',
  data() {
    return {
      scaleStyle: {
        transform: 'scale(1)',
        transformOrigin: 'left top',
        width: '1280px'          // 设计稿基准
      }
    }
  },
  mounted() {
    /* 1. 子树变化（节点增减、文本变化） */
    this.mo = new MutationObserver(() => this.updateScale())
    this.mo.observe(this.$refs.inner, {
      childList: true,
      subtree: true,
      characterData: true
    })

    /* 2. 子元素尺寸变化（图片加载、表格展开等） */
    this.ro = new ResizeObserver(() => this.updateScale())
    this.ro.observe(this.$refs.inner)
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
  },
  beforeDestroy() {
    if (this.mo) {
      this.mo.disconnect()
    }
    if (this.ro) {
      this.ro.disconnect()
    }
    window.removeEventListener('resize', this.updateScale)
  },
  methods: {
    updateScale() {
      console.log(this.$refs.inner.offsetHeight)
      if (!this.$refs.wrap || !this.$refs.inner) return
      const cw = this.$refs.wrap.clientWidth          // 实际视口宽度
      const base = 1280                           // 设计稿宽度
      const ratio = cw / base
      this.scaleStyle.transform = `scale(${ratio})`
      // 把高度同步回去，避免下方 DOM 塌陷
      this.$refs.wrap.style.height = this.$refs.inner.offsetHeight * ratio + 'px'
    }
  }
}
</script>

<style scoped>
.scale-wrap {
  width: 100%;
  overflow: hidden;   /* 把可能出现的横向滚动条藏掉 */
}
.scale-inner {
  width: 750px;
}
</style>


// WEBPACK FOOTER //
// src/components/ScaleBox.vue